import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const departamentoImporterSelectors = importerSelectors(
  'departamento.importer',
);

export default departamentoImporterSelectors;
